import React, { useEffect, useState } from "react";
import { usePFDataContext } from "../../context/PfContext";
import ReactSlider from "react-slider";

const ThcPriceSlider = () => {
  const { updatePfData } = usePFDataContext();
  const { pfData } = usePFDataContext();

  // State to hold dynamically calculated min and max values
  const [thcRange, setThcRange] = useState({ min: 0, max: 100 });
  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  // State to hold current slider values
  const [selectedThc, setSelectedThc] = useState([0, 100]);
  const [selectedPrice, setSelectedPrice] = useState([0, 100]);

  useEffect(() => {
    let thcMin = Infinity, thcMax = -Infinity;
    let priceMin = Infinity, priceMax = -Infinity;

    Object.values(pfData.pfProducts).forEach((brand) => {
      Object.values(brand.categories || {}).forEach((products) => {
        products.forEach((product) => {
          if (product.thc_percentage !== undefined) {
            thcMin = Math.min(thcMin, product.thc_percentage);
            thcMax = Math.max(thcMax, product.thc_percentage);
          }

          if (product.price_per_unit !== undefined) {
            priceMin = Math.min(priceMin, product.price_per_unit);
            priceMax = Math.max(priceMax, product.price_per_unit);
          }
        });
      });
    });

    if (thcMin === thcMax) thcMax = thcMin + 1;
    if (priceMin === priceMax) priceMax = priceMin + 1;

    setThcRange({ min: thcMin === Infinity ? 0 : thcMin, max: thcMax });
    setPriceRange({ min: priceMin === Infinity ? 0 : priceMin, max: priceMax });

    setSelectedThc([thcMin, thcMax]);
    setSelectedPrice([priceMin, priceMax]);
  }, [pfData.pfProducts]);

  const handleSliderChange = (key, values) => {
    if (key === "thcRange") {
      setSelectedThc(values);
    } else if (key === "priceRange") {
      setSelectedPrice(values);
    }
  };


  const applyPriceFilter = () => {
    updatePfData("priceRange", selectedPrice)
  };

  const applyThcFilter = () => {
    updatePfData("thcRange", selectedThc)
  };

  return (
   <>
      <div className="slider-container">
        <div className="filter__slider">
          <p style={{ textAlign: "center" }}>THC %</p>
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="thumb"
            trackClassName="track"
            value={selectedThc}
            min={thcRange.min}
            max={thcRange.max}
            step={1}
            ariaLabel={["Min THC", "Max THC"]}
            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
            pearling
            onChange={(values) => handleSliderChange("thcRange", values)}
          />
        </div>
        <button 
        className="filter__slider-btn"
        onClick={applyThcFilter}
      >Go</button>
      </div>

      <div className="slider-container">
        <div className="filter__slider">
          <p style={{ textAlign: "center" }}>Price</p>
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="thumb"
            trackClassName="track"
            value={selectedPrice}
            min={priceRange.min}
            max={priceRange.max}
            step={.5}
            ariaLabel={["Min Price", "Max Price"]}
            renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
            pearling
            onChange={(values) => handleSliderChange("priceRange", values)}  // Less frequent updates

          />
        </div>
        <button 
          className="filter__slider-btn"
          onClick={applyPriceFilter}
        >Go</button>
      </div>
     
    </>
  );
};

export default ThcPriceSlider;
